import { render, staticRenderFns } from "./OrderTypeChart.vue?vue&type=template&id=667807c7&scoped=true"
import script from "./OrderTypeChart.vue?vue&type=script&lang=js"
export * from "./OrderTypeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667807c7",
  null
  
)

export default component.exports